// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__85O4A","nav-content-wrapper":"Navbar_nav-content-wrapper__1V+XR","user-auth-link":"Navbar_user-auth-link__DsMeP"};